<div class="m-5 pt-5" id="services">
  <div class="row justify-content-around text-center text-md-start">
    <div class="col-12 col-sm-6 col-md-4 px-4">
      <img src="../../../assets/img/resume.png" class="" />

      <div class="title">
        {{ "Build a Professional CV in minutes" | translate }}
      </div>
      <p class="discreption">
        {{ "Craft a job winning resume" | translate
        }}<span> {{ "online CV Builder" | translate }}</span>
        {{ "Use our cover letter generator" | translate }}
      </p>
    </div>

    <div class="col-12 col-sm-6 col-md-4 px-4">
      <img src="../../../assets/img/linkedIn.png" class="img-fluid" />

      <div class="title">{{ "Build a Professional LinkedIn" | translate }}</div>
      <p class="discreption">
        {{ "Completing all sections" | translate }}
      </p>
    </div>

    <div class="col-12 col-sm-6 col-md-4 px-4">
      <img src="../../../assets/img/goal.png" class="img-fluid" />

      <div class="title">{{ "Free ATS friendly templates" | translate }}</div>
      <p class="discreption">
        {{ "Our customizable CV" | translate }}
        <span> {{ "applicant tracking system (ATS)." | translate }}</span>
        {{ "Beat the bots and get notices by recruiters." | translate }}
      </p>
    </div>

    <div class="col-12 col-sm-6 col-md-4 px-4">
      <img src="../../../assets/img/robote.png" class="w-md-50 h-md-50" />

      <div class="title">{{ "Interview Training with AI" | translate }}</div>
      <p class="discreption">
        {{ "Enhance your interview skill" | translate }}
      </p>
    </div>

    <div class="col-12 col-sm-6 col-md-4 px-4">
      <img
        class="img"
        src="../../../assets/img/career.png"
        class="w-md-50 h-md-50"
      />

      <div class="title">{{ "Career Coach with Human" | translate }}</div>
      <p class="discreption">
        {{ "Get personalized coaching" | translate }}
      </p>
    </div>

    <div class="col-12 col-sm-6 col-md-4 px-4">
      <img src="../../../assets/img/bag.png" class="w-md-50 h-md-50" />

      <div class="title">{{ "Auto apply based-on CV Skills" | translate }}</div>
      <p class="discreption">
        {{ "Automatically apply to job" | translate }}
      </p>
    </div>
  </div>
</div>
